// Split out so TwoZoneUpload.js doesn't grow past the file-size standard.
export default function SelfScanButton({ filename, onClick, disabled }) {
  return (
    <div className="tz-compare-row">
      <button
        className="tz-compare-btn"
        onClick={onClick}
        disabled={disabled}
        aria-label={`Check ${filename} for internal conflicts`}
      >
        Check {filename} for internal conflicts
      </button>
    </div>
  );
}
